// utils/exportUtils.js
import { fieldEntityActionConfig } from '../components/crud/utils/fieldEntityActionConfig';

export const enrichUpdatedEntity = async (updatedEntity) => {
  const enrichedEntity = { ...updatedEntity };

  for (const [key, value] of Object.entries(updatedEntity)) {
    const config = fieldEntityActionConfig[key];
    if (config && config.listEntitiesByIds) {
      if (Array.isArray(value) && value.length > 0) {
        enrichedEntity[key] = await config.listEntitiesByIds(value);
      } else if (value && !Array.isArray(value)) {
        const result = await config.listEntitiesByIds([value]);
        enrichedEntity[key] = result[0];
      }
    }
  }

  return enrichedEntity;
};

const flattenObject = (obj, prefix = '') => {
  return Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? prefix + '.' : '';
    if (typeof obj[k] === 'object' && obj[k] !== null && !Array.isArray(obj[k])) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else if (Array.isArray(obj[k])) {
      acc[pre + k] = obj[k]?.map(item => typeof item === 'object' ? JSON.stringify(item) : item).join('; ');
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});
};

export const escapeCsvCell = (value) => {
  if (value == null || value === '') return '';
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

/** @param {{ label: string, getValue: (row: object) => unknown }[]} columns */
export const downloadCsvFromRows = (rows, columns, filename = 'export.csv') => {
  const headerLine = columns.map((c) => escapeCsvCell(c.label)).join(',');
  const body = rows.map((row) =>
    columns.map((c) => escapeCsvCell(c.getValue(row))).join(','),
  );
  const csv = `\uFEFF${[headerLine, ...body].join('\n')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename.endsWith('.csv') ? filename : `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const tsvCell = (value) => String(value ?? '').replace(/[\t\n\r]/g, ' ');

/** Tab-separated text for clipboard copy (Excel-friendly). */
export function tabSeparatedTextFromRows(rows, columns, formatValue = (v) => (v == null ? '' : String(v))) {
  const header = columns.map(c => tsvCell(c.label || c.key)).join('\t');
  const body = rows.map(row =>
    columns.map(c => tsvCell(formatValue(row[c.key], c.type))).join('\t'),
  );
  return [header, ...body].join('\n');
}

export const exportToCSV = (data) => {
  const flattenedData = flattenObject(data);
  const csvContent = Object.entries(flattenedData)
    ?.map(([key, value]) => `"${key}","${value}"`)
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'export.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};